import { render, staticRenderFns } from "./RelationshipsNewContact.vue?vue&type=template&id=563f17ff&"
import script from "./RelationshipsNewContact.vue?vue&type=script&lang=js&"
export * from "./RelationshipsNewContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports